import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { Text } from '../Text/Text.js';
import styles from './FormLabel.module.css.js';
import clsx from 'clsx';

const FormLabel = ({ isRequired, htmlFor, children, disabled }) => {
    const labelClassName = clsx(styles.label, {
        [styles.disabled]: disabled,
        [styles.required]: isRequired,
    });
    return (jsxRuntimeExports.jsx(Text, { as: "label", type: "bodyHeavy", htmlFor: htmlFor, className: labelClassName, children: children }));
};

export { FormLabel };
//# sourceMappingURL=FormLabel.js.map
